import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeZoneLocalizationService {

  private readonly europeLondonLabel = $localize`:@@communication-centre.timezone.europe.london:Europe/London`;
  private readonly europeDublinLabel = $localize`:@@communication-centre.timezone.europe.dublin:Europe/Dublin`;
  private readonly europeHelsinkiLabel = $localize`:@@communication-centre.timezone.europe.helsinki:Europe/Helsinki`;
  private readonly europeParisLabel = $localize`:@@communication-centre.timezone.europe.paris:Europe/Paris`;
  private readonly americaChicagoLabel = $localize`:@@communication-centre.timezone.america.chicago:Central Time Zone`;
  private readonly americaLosAngelesLabel = $localize`:@@communication-centre.timezone.america.los_angeles:Pacific Time Zone`;
  private readonly americaNewYorkLabel = $localize`:@@communication-centre.timezone.america.new_york:Eastern Time Zone`;
  private readonly americaPhoenixLabel = $localize`:@@communication-centre.timezone.america.phoenix:Mountain Time Zone`;
  private readonly utcLabel = $localize`:@@communication-centre.timezone.utc:UTC`;

  public localizeName(
    label: string
  ): string {

    switch (label) {

      case 'Europe/London':
      case 'timezone.europe.london':
        return this.europeLondonLabel;

      case 'Europe/Dublin':
      case 'timezone.europe.dublin':
        return this.europeDublinLabel;

      case 'Europe/Helsinki':
      case 'timezone.europe.helsinki':
        return this.europeHelsinkiLabel;

      case 'Europe/Paris':
      case 'timezone.europe.paris':
        return this.europeParisLabel;

      case 'America/Chicago':
      case 'timezone.america.chicago':
        return this.americaChicagoLabel;

      case 'America/Los_Angeles':
      case 'timezone.america.los_angeles':
        return this.americaLosAngelesLabel;

      case 'America/New_York':
      case 'timezone.america.new_york':
        return this.americaNewYorkLabel;

      case 'America/Phoenix':
      case 'timezone.america.phoenix':
        return this.americaPhoenixLabel;

      case 'UTC':
      case 'timezone.utc':
        return this.utcLabel;

      default:
        return label;

    }

  }

}
